import { all, call, put, takeLatest } from "redux-saga/effects";

import { showLoader, hideLoader } from "../actions/app-action-types";

import {
  AddVariantFeatures,
  DisableVariantFeature,
  EnableVariantFeature,
  GetAllGroupFeatures,
  GetAllMachineFeatureMapping,
  UpdateFeatureDetail,
  UploadModelDoc,
  UploadVariantImage,
} from "../api";
import {
  ADD_VARIANT_FEATURES,
  addVariantFeaturesFailure,
  addVariantFeaturesSuccess,
  DISABLE_VARIANT_FEATURE,
  disableVariantFeatureFailure,
  disableVariantFeatureSuccess,
  ENABLE_VARIANT_FEATURE,
  enableVariantFeatureFailure,
  enableVariantFeatureSuccess,
  GET_ALL_FEATURES,
  GET_ALL_MACHINE_FEATURE,
  getAllFeaturesFailure,
  getAllFeaturesSuccess,
  getAllMachineFeatureFailure,
  getAllMachineFeatureSuccess,
  UPDATE_FEATURE_DETAIL,
  updateFeatureDetailFailure,
  updateFeatureDetailSuccess,
  UPLOAD_MODEL_DOC,
  UPLOAD_VARIANT_IMAGE,
  uploadModelDocFailure,
  uploadModelDocSuccess,
  uploadVariantImageFailure,
  uploadVariantImageSuccess,
} from "../actions/machine-action-types";

// Get All Machine Feature Mapping
function* getAllMachineFeature() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllMachineFeatureMapping);
    yield put(getAllMachineFeatureSuccess(result ?? []));
  } catch (error) {
    yield put(getAllMachineFeatureFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All Features along with Feature Groups
function* getAllFeatures() {
  yield put(showLoader());
  try {
    const result = yield call(GetAllGroupFeatures);
    yield put(getAllFeaturesSuccess(result ?? []));
  } catch (error) {
    yield put(getAllFeaturesFailure({ error }));
  }
  yield put(hideLoader());
}

function* uploadVariantImage(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => UploadVariantImage(val.payload.params));
    yield put(uploadVariantImageSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(uploadVariantImageFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* uploadModelDoc(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => UploadModelDoc(val.payload.params));
    yield put(uploadModelDocSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(uploadModelDocFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* addVariantFeatures(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => AddVariantFeatures(val.payload.params));
    yield put(addVariantFeaturesSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(addVariantFeaturesFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* updateFeatureDetail(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => UpdateFeatureDetail(val.payload.params));
    yield put(updateFeatureDetailSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(updateFeatureDetailFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* disableVariantFeature(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => DisableVariantFeature(val.payload.params));
    yield put(disableVariantFeatureSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(disableVariantFeatureFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* enableVariantFeature(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => EnableVariantFeature(val.payload.params));
    yield put(enableVariantFeatureSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(enableVariantFeatureFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

// Combine all user action into one saga function.
function* Machine() {
  yield all([takeLatest(GET_ALL_MACHINE_FEATURE, getAllMachineFeature)]);
  yield all([takeLatest(GET_ALL_FEATURES, getAllFeatures)]);
  yield all([takeLatest(UPLOAD_VARIANT_IMAGE, uploadVariantImage)]);
  yield all([takeLatest(UPLOAD_MODEL_DOC, uploadModelDoc)]);
  yield all([takeLatest(ADD_VARIANT_FEATURES, addVariantFeatures)]);
  yield all([takeLatest(UPDATE_FEATURE_DETAIL, updateFeatureDetail)]);
  yield all([takeLatest(DISABLE_VARIANT_FEATURE, disableVariantFeature)]);
  yield all([takeLatest(ENABLE_VARIANT_FEATURE, enableVariantFeature)]);
}

export default Machine;
